import React from 'react';

import classes from './ReportsPageHeader.module.css';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import { format, parseISO } from 'date-fns';
import { useTranslation } from '../../../hooks/useTranslations';

interface PageHeaderProps {
  label?: string;
  selectedSalesOrder?: SalesOrderInfo;
  onBackButtonClick: () => void;
}

const ReportsPageHeader: React.FC<PageHeaderProps> = ({
  label,
  selectedSalesOrder,
  onBackButtonClick,
}: PageHeaderProps) => {
  const { translations } = useTranslation();

  return (
    <div
      className={`${classes.container} ${selectedSalesOrder ? classes.containerWithDetails : ''}`}
    >
      <div className={classes.content}>
        <div className={classes.mainTitle}>
          <div className={classes.backButton} onClick={() => onBackButtonClick()}>
            {label}
          </div>
          {selectedSalesOrder && (
            <div className={classes.costumerName}>{`${label ? ' / ' : ''}${
              selectedSalesOrder?.customer_person?.person_firstname
            } ${selectedSalesOrder?.customer_person?.person_lastname}`}</div>
          )}
        </div>
        {selectedSalesOrder && (
          <div className={classes.secondaryTitle}>
            <div className={classes.secondaryTitleItem}>
              ID: {selectedSalesOrder.sales_order.sales_order_id}
            </div>
            <div className={classes.secondaryTitleItem}>
              {selectedSalesOrder.service.service_name}
            </div>
            {selectedSalesOrder?.sales_order?.datetime_create && (
              <div className={classes.secondaryTitleItem}>
                |{'  '}
                {format(
                  parseISO(selectedSalesOrder?.sales_order?.datetime_create?.toString()),
                  'dd.MM.yyyy HH:mm'
                )}
                {'  '}|
              </div>
            )}
            {selectedSalesOrder?.work_order?.work_order_status_id
              ? selectedSalesOrder.work_order.work_order_status_id === 1
                ? translations('pending')
                : selectedSalesOrder.work_order.work_order_status_id === 4
                ? translations('parked')
                : translations('closed')
              : translations('open')}
          </div>
        )}
      </div>
      <div className={classes.rightPart}></div>
    </div>
  );
};

export { ReportsPageHeader };
